export enum MethodEnum {
  Now = 'now',
  Future = 'future',
  Draft = 'draft',
}
